import React from 'react';
import {useNode} from '@craftjs/core';
import {useEditorStyle} from 'hooks';
import {Divider} from 'components';

import EditorInspectorDimension from '../../inspectors/Editor.Inspector.Dimension';
import EditorInspectorPadding from '../../inspectors/Editor.Inspector.Padding';
import EditorInspectorMargin from '../../inspectors/Editor.Inspector.Margin';

interface IEditorInspectorQRProps {}

const EditorInspectorQR = ({}: IEditorInspectorQRProps) => {
  const {
    actions: {setProp},
  } = useNode();

  const {device, style} = useEditorStyle();

  return (
    <div key={device}>
      <h4 className="text-slate-800 dark:text-white font-semibold">QR Code</h4>
      <Divider />
      {(() => {
        if (device === 'mobile') {
          return <p>This component is only for desktop view.</p>;
        }
        return (
          <>
            <EditorInspectorDimension style={style} setProp={setProp} />
            <Divider />
            <EditorInspectorPadding style={style} setProp={setProp} />
            <Divider />
            <EditorInspectorMargin style={style} setProp={setProp} />
          </>
        );
      })()}
    </div>
  );
};

export default React.memo(EditorInspectorQR);
